// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountUpsearchResponseModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountUpsearchResponseModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountUpsearchResponseModel.discriminator = undefined;
EnterpriseCoordinatorAccountUpsearchResponseModel.additionalProperties = false;
EnterpriseCoordinatorAccountUpsearchResponseModel.attributeTypeMap = [
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountUpsearchResponseModel.js.map